import React, { useEffect, useState } from 'react';

// import { useHistory } from 'react-router-dom';
import { Button } from 'govuk-react-jsx';
import { useSelector } from 'react-redux';
import {
  getDashboardLink,
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import {
  getApplicationClaimId,
  getGrantTypeDynamicWording,
} from '../../features/installer/installerJourneySlice';
import useGaEndEvent from '../../hooks/useGaEndEvent';
import useTitle from '../../hooks/useTitle';
import { getWordingTemplates } from '../../firebase';

const ClaimSubmitted = () => {
  // const history = useHistory();
  const grantTypeDynamicWording = useSelector(getGrantTypeDynamicWording);
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const dashboardLink = useSelector(getDashboardLink);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;
  const [dynamicWording, setDynamicWording] = useState({
    message: null,
    is_dynamic: false,
  });
  const [isLoading, setIsLoading] = useState(true);

  useTitle(
    'installer.ClaimSubmitted.s12',
    'We will now review your claim - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );
  const claimIdRedux = useSelector(getApplicationClaimId);

  useGaEndEvent('LanlordInstallerSubmitClaim', 'lr_installer_submit_claim_end');

  const handleButton = () => {
    // history.push('/dashboardHub/dashboard');
    window.location.assign(dashboardLink);
  };
  useEffect(() => {
    console.log('slice grantType:', grantTypeDynamicWording);
    const fetchWordingTemplates = async () => {
      try {
        setIsLoading(true);
        const response = await getWordingTemplates({
          grantType: grantTypeDynamicWording,
        });

        if (response.data?.success && response.data?.data) {
          setDynamicWording({
            message: response.data.data,
            is_dynamic: response.data.data.is_dynamic,
          });
        }
      } catch (error) {
        console.error('Error fetching wording templates:', error);
      } finally {
        setIsLoading(false); // ✅ End loading
      }
    };

    fetchWordingTemplates(); // ✅ Call the async function
  }, [currentLanguage]);

  const getMessage = () => {
    // Before activation → Show hardcoded

    if (!dynamicWording.is_dynamic) {
      return copyProvider.getCopy(
        'installer.ClaimSubmitted.s6',
        'We will aim to tell you, within 20 working days, whether your claim is successful, or to ask you for more information.'
      );
    }

    // After activation:

    const message =
      currentLanguage === 'en'
        ? dynamicWording.message.notification20_message_en
        : dynamicWording.message.notification20_message_cy;

    if (message === '') {
      return '';
    }

    // If null or undefined → Show hardcoded
    if (message === null || message === undefined) {
      return copyProvider.getCopy(
        'installer.ClaimSubmitted.s6',
        'We will aim to tell you, within 20 working days, whether your claim is successful, or to ask you for more information.'
      );
    }

    // If has value → Show dynamic text
    return message;
  };
  if (isLoading) {
    return (
      <div className="govuk-grid-row">
        <p className="govuk-body">Loading...</p>
      </div>
    );
  }
  const pageModel = (
    <div className="govuk-grid-row">
      <div className="govuk-panel govuk-panel--confirmation">
        <h1 className="govuk-panel__title">
          {copyProvider.getCopy(
            'installer.ClaimSubmitted.s1',
            'We will now review your claim'
          )}
        </h1>
        <div className="govuk-panel__body">
          {copyProvider.getCopy(
            'installer.ClaimSubmitted.s2',
            'Your reference number:'
          )}
          <br />
          <strong>{claimIdRedux}</strong>
        </div>
      </div>

      <p className="govuk-body">
        {copyProvider.getCopy(
          'installer.ClaimSubmitted.s3',
          ' We have sent your customer an email to tell them you have finished your claim.'
        )}
      </p>
      <h2 className="govuk-heading-m">
        {copyProvider.getCopy(
          'installer.ClaimSubmitted.s4',
          'What happens next'
        )}
      </h2>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'installer.ClaimSubmitted.s5',
          'The Office for Zero Emission Vehicles (OZEV) will now assess your claim.'
        )}
      </p>
      <p className="govuk-body">{getMessage()}</p>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'installer.ClaimSubmitted.s7',
          'You can check the progress of your claim on your manage your claims page.'
        )}
      </p>
      <div className="govuk-button-group govuk-!-margin-top-5">
        <Button className="govuk-button" onClick={handleButton}>
          {copyProvider.getCopy(
            'installer.ClaimSubmitted.s10',
            'Manage your claims'
          )}
        </Button>
      </div>
      <h3 className="govuk-heading-m">
        {copyProvider.getCopy(
          'installer.ClaimSubmitted.s11',
          'Help to make this service better'
        )}
      </h3>
      <p className="govuk-body">
        <a
          href="https://www.smartsurvey.co.uk/s/EV-grants/"
          target="_blank"
          rel="noopener noreferrer"
          className="govuk-link"
        >
          {copyProvider.getCopy(
            'installer.ClaimSubmitted.s8',
            'What did you think of this service?'
          )}
        </a>{' '}
        {copyProvider.getCopy(
          'installer.ClaimSubmitted.s9',
          ' (takes 30 seconds)'
        )}
      </p>
    </div>
  );
  return pageModel;
};

export default ClaimSubmitted;
